import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import axios from 'axios';
const BE_URI = process.env.REACT_APP_BE_URI;

const CreateWifiSectionModal = ({
  modalVisible,
  setModalVisible,
  token,
  wifiSections,
  setWifiSections,
  activeGroup,
  t,
  buttonColor,
}) => {
  const [name, setName] = useState('');

  const handleOnChangeText = (event) => {
    setName(event.target.value);
  };

  const handleCreateWifiSection = async () => {
    try {
      const currentMaxSequence = Math.max(
        ...wifiSections.map((wS) => wS.sequence),
        0
      );
      const newSequence = currentMaxSequence + 1;
      const formData = {
        name,
        groupId: activeGroup,
        sequence: newSequence,
      };
      
      const res = await axios.post(BE_URI + '/create-wifiSection', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (res.data.success) {
        setWifiSections([...wifiSections, res.data.wifiSection]);
      } else {
        console.log('Error: ' + res.data.message);
      }
    } catch (error) {
      console.log('Error: ' + error);
    }
    setModalVisible(false);
  };

  return (
    <Dialog open={modalVisible} onClose={() => setModalVisible(false)}>
      <DialogTitle style={{ backgroundColor: buttonColor, color: '#FFFFFF', textAlign: 'center' }}>
        {t("CreateWifiSection")}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Name"
          placeholder={t("FullName")}
          value={name}
          onChange={handleOnChangeText}
          margin="dense"
        />
      </DialogContent>
      <DialogActions>
        <Button style={{ backgroundColor: buttonColor, color: '#FFFFFF' }} onClick={() => setModalVisible(false)}>
          {t("Cancel")}
        </Button>
        <Button style={{ backgroundColor: buttonColor, color: '#FFFFFF' }} onClick={handleCreateWifiSection}>
          {t("Ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateWifiSectionModal;
